import { useState, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import InputText from 'Shared/components/input-text';
import Button from 'Shared/components/button';
import { useMaxWidth, useTranslation } from 'Shared/util/custom-hooks';
import styles from './search.css';


const Search = () => {
  const [searchText, setSearchText] = useState('');
  const [inputRef, setInputRef] = useState(null);
  const history = useHistory();
  const isMobileView = useMaxWidth(480);
  const t = useTranslation(x => x.search);

  const inputCallback = useCallback((ref) => {
    setInputRef(ref);
    if (ref) ref.focus();
  }, [inputRef]);


  const doSearch = () => {
    if (searchText.length > 0 && inputRef) {
      inputRef.blur();
      history.push(`/search-result?terms=${searchText}`);
    }
  };

  const handleButtonClick = () => doSearch();
  const handleKeyPress = (e) => (e.key === 'Enter' && doSearch());

  return (
    <div className={styles.search}>
      <form action="#" className={styles.container}>
        <InputText
          ref={inputCallback}
          inputType="search-customer"
          value={searchText}
          className={styles.searchField}
          onChange={(e) => setSearchText(e.target.value)}
          onKeyDown={handleKeyPress}
        />
        { !isMobileView && (
        <Button
          text={t.search}
          onClick={handleButtonClick}
        />
        )}
      </form>
    </div>
  );
};

export default Search;
